import { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [render, setRender] = useState(false);
  const [isShowUpdateModal, setIsShowUpdateModal] = useState(false);
  const [taskId, setTaskId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [deviceTasks, setDeviceTasks] = useState({});

  // Generate a unique key for each task (hostname + command)
  const getTaskKey = (hostname, command) => `${hostname}-${command}`;

  // Adds or updates a device task
  const updateDeviceTask = (hostname, command, taskData) => {
    const taskKey = getTaskKey(hostname, command);
    setDeviceTasks((prev) => ({
      ...prev,
      [taskKey]: {
        hostname,
        command,
        ...prev[taskKey],
        ...taskData,
      },
    }));
  };

  // To Remove a device task
  const removeDeviceTask = (hostname, command) => {
    const taskKey = getTaskKey(hostname, command);
    setDeviceTasks((prev) => {
      const newTasks = { ...prev };
      delete newTasks[taskKey];
      return newTasks;
    });
  };

  const clearAllTasks = () => {
    setDeviceTasks({});
    setTaskId(null);
    setIsShowUpdateModal(false);
    setData([]);
    setRender((prev) => !prev); // Force refresh
  };

  // Check if a device has an active task of specific command
  const isDeviceTaskActive = (hostname, command) => {
    const taskKey = getTaskKey(hostname, command);
    return (
      !!deviceTasks[taskKey] &&
      ["pending", "running"].includes(deviceTasks[taskKey].status)
    );
  };

  // Specific helper for reboot (backwards compatibility)
  const isDeviceRebooting = (hostname, command) => {
    return isDeviceTaskActive(hostname, "reboot");
  };

  const isDeviceSyncing = (hostname, command) => {
    return isDeviceTaskActive(hostname, "sync");
  };

  return (
    <HeaderContext.Provider
      value={{
        render,
        setRender,
        isShowUpdateModal,
        setIsShowUpdateModal,
        taskId,
        setTaskId,
        data,
        setData,
        deviceTasks,
        updateDeviceTask,
        removeDeviceTask,
        isDeviceTaskActive,
        isDeviceRebooting,
        clearAllTasks,
        isDeviceSyncing,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => useContext(HeaderContext);
